import script from "./8Z40.vue?vue&type=script&setup=true&lang=js"
export * from "./8Z40.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__